import { useState } from 'react';
import { Calculator, RotateCcw } from 'lucide-react';
import { usePermission } from '@/hooks/usePermission';
import PedsDoseCalculator from '@/components/PedsCalculator/PedsDoseCalculator';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/ui/page-header';
import { usePageTitle } from "@/hooks/usePageTitle";

export default function PedsCalculatorPage() {
  usePageTitle('Dose calculator');
  const { hasFeature } = usePermission();
  // Remounting the calculator is the simplest complete reset
  const [resetKey, setResetKey] = useState(0);

  if (!hasFeature('peds_calculator')) {
    return (
        <div className="flex flex-col items-center justify-center h-full text-center px-4 py-20">
          <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center mb-4">
            <Calculator className="w-6 h-6 text-muted-foreground" />
          </div>
          <h2 className="text-base font-semibold mb-1">Pediatric calculator not available</h2>
          <p className="text-sm text-muted-foreground max-w-xs">
            Not included in your current plan. Contact support to upgrade.
          </p>
        </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-5">
      <PageHeader
        icon={Calculator}
        title="Pediatric dose calculator"
        className="mb-4"
        actions={
          <Button variant="ghost" size="sm" onClick={() => setResetKey(k => k + 1)} className="gap-1.5 text-muted-foreground">
            <RotateCcw className="w-4 h-4" /> Reset
          </Button>
        }
      />

      <PedsDoseCalculator key={resetKey} />

      <p className="text-2xs text-muted-foreground text-center mt-3">
        Reference only — verify against current pediatric dosing guidelines before prescribing.
      </p>
    </div>
  );
}
